import React, { useState } from 'react'
import { IconPencil } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { getFormSchema } from '@/views/PlaybookMapping/helpers'

export const EditCampaignModal = ({
  onSubmit,
  editingCampaign,
  dropdownOptions = [],
  loading = false,
}) => {
  const isUnmatchedEdit = editingCampaign?.isUnmatched
  const [open, setOpen] = useState(false)

  const handleSubmit = async (formValues) => {
    await onSubmit({
      campaignName: isUnmatchedEdit ? editingCampaign.name : formValues.name,
      configCid: formValues.config_cid,
      isEdit: true,
      isUnmatchedEdit,
      editingCampaign,
    })
    setOpen(false)
  }

  const getExistingValues = () => ({
    name: editingCampaign?.name || '',
    config_cid: editingCampaign?.config_cid || '',
  })

  return (
    <>
      <Button
        square
        basic
        small
        onClick={() => setOpen(true)}
        data-testid="edit-campaign-button"
        tooltip="Edit Campaign"
      >
        <IconPencil />
      </Button>

      <BasicModal
        title={isUnmatchedEdit ? 'Map Unmatched Call' : 'Edit VoIP Campaign'}
        onClose={() => setOpen(false)}
        show={open}
        size="tiny"
      >
        <AbstractForm
          existingValues={getExistingValues()}
          schema={getFormSchema(dropdownOptions, isUnmatchedEdit)}
          onSubmit={handleSubmit}
          buttonLabel="Update"
          isModal
          buttonProps={{ disabled: loading }}
          closeButtonProps={{ disabled: loading }}
          onClose={() => setOpen(false)}
        />
      </BasicModal>
    </>
  )
}
